export default __webpack_public_path__ + "b15104ef77d1dcc9e40e23f565a9274d.png";